// cross-project constants

// the shopify project uses these keys and must be changed there if these
// are modified
exports.SHOPIFY_ORDER_CUSTOM_ATTRIBUTE_GIFT_TEXT_KEY = 'giftText'
exports.SHOPIFY_ORDER_CUSTOM_ATTRIBUTE_GIFT_EMAIL_KEY = 'giftEmail'
exports.SHOPIFY_ORDER_CUSTOM_ATTRIBUTE_GIFT_EMAIL_DELIVERED_KEY = 'giftEmailDelivered'
exports.SHOPIFY_GIFT_CARD_PRODUCT_TYPE = 'Gift Card'

exports.SANITY_SHOPIFY_GIFT_CARD_SLUG = 'gift-card'